// @ts-nocheck
import React from 'react';
import { useMatches } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from '@chakra-ui/react';

export const Breadcrumbs = (): JSX.Element => {
  let matches = useMatches();
  let crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .map((match) => match.handle.crumb(match.params, location.search));

  return (
    <Breadcrumb>
      {crumbs.map((crumb, index) => {
        return (
          <BreadcrumbItem isCurrentPage key={index} color="#939598">
            {crumb}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};
